export default __webpack_public_path__ + "static/media/new_campus.23aa2a04.jpg";